import { action, thunk } from 'easy-peasy';

import { getOrdersForMultiplePrint } from '../../api/orders';
import handleError from '../../api/apiErrorHandle';
import createLatestRequestSignal from '../../services/latestRequestSignalService';

import { PrintExistingLabelStoreModel } from './printExistinglabelStoreTypes';

const nextOrdersListSignal = createLatestRequestSignal();

const printExistingLabels: PrintExistingLabelStoreModel = {
  loading: false,
  orders: [],
  selectedOrders: [],
  totalPdfPages: 0,

  total: 0,
  currentFilter: {
    page: 1,
    orderBy: 'id',
    orderDirection: 'desc',
    filter: {
      globalFilter: '',
      deliveryTypes: [],
    },
  },

  fetchOrders: thunk(async (actions, payload) => {
    const signal = nextOrdersListSignal();

    actions.setLoading(true);
    actions.selectOrders([]);
    try {
      const { data } = await getOrdersForMultiplePrint(payload, signal);

      actions.setOrders({ total: data.total, orders: data.data });
    } catch (error) {
      handleError(error);
    } finally {
      if (!signal.aborted) {
        actions.setLoading(false);
      }
    }
  }),
  setOrders: action((state, payload) => {
    state.total = payload.total;
    state.orders = payload.orders;
  }),
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setFilter: action((state, payload) => {
    state.currentFilter = payload;
  }),
  selectOrders: action((state, payload) => {
    state.selectedOrders = payload;
    const selected = state.orders
      .filter(o => payload.indexOf(o.id) >= 0)
      .map(o => o.pagesCount ?? 0);

    state.totalPdfPages = selected.reduce((sum, value) => sum + value, 0);
  }),
};

export default printExistingLabels;
